module.exports = __webpack_public_path__ + "static/2-2d3c921f26398be5981bc12abb845aed.jpeg";